<div visanaLibFocusTrap *visanaLibHideForBreakpoint="'for-Small-Down'">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</div>

<div *visanaLibShowForBreakpoint="'for-Small-Down'">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</div>

<ng-template #content>
  <visana-lib-overlay-backdrop (click)="closed.emit()"></visana-lib-overlay-backdrop>
  <visana-lib-scroll-lock></visana-lib-scroll-lock>

  <div class="overlay">
    <ng-content></ng-content>
  </div>
</ng-template>
